var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconIonicIosCreate = function SvgIconIonicIosCreate(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.916,
    height: 31.911,
    viewBox: "0 0 31.916 31.911",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_24",
    x: 0,
    y: 1.772,
    width: 30.139,
    height: 30.139,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_25",
    x: 11.202,
    y: 0,
    width: 20.714,
    height: 20.723,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-create",
    "data-name": "Icon ionic-ios-create",
    transform: "translate(0.653 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(8.347 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24-2",
    "data-name": "Path 24",
    d: "M24.213,6,14.177,16.035a.391.391,0,0,0-.114.278V17.63a.393.393,0,0,0,.392.392h1.307a.4.4,0,0,0,.283-.114L26.086,7.872a.393.393,0,0,0,0-.556L24.769,6A.393.393,0,0,0,24.213,6Z",
    transform: "translate(-5.06 1.89)",
    fill: "#bcbcbc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25-2",
    "data-name": "Path 25",
    d: "M32.407,4.319,31.691,3.6l-.01-.01a.878.878,0,0,0-.571-.219.861.861,0,0,0-.576.224l-.561.566a.2.2,0,0,0,0,.278l.517.517,1.078,1.078a.2.2,0,0,0,.283,0l.561-.561A.847.847,0,0,0,32.63,4.9.9.9,0,0,0,32.407,4.319Z",
    transform: "translate(-9.71 2.62)",
    fill: "#bcbcbc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M13.081,19.523a.8.8,0,0,1-.561.234H10.463a.8.8,0,0,1-.795-.795V16.9a.8.8,0,0,1,.234-.561l.04-.04,7.333-7.333a.2.2,0,0,0-.139-.338H5.166A2.918,2.918,0,0,0,2.25,11.544V22.673a2.918,2.918,0,0,0,2.916,2.916H17.885A2.918,2.918,0,0,0,20.8,22.673V12.289a.2.2,0,0,0-.338-.139l-7.343,7.333Z",
    transform: "translate(-2.25 -4.916)",
    fill: "#bcbcbc"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconIonicIosCreate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icon ionic-ios-create.7d78666bf926d6495789d69fc2eaa566.svg";